var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCitytree(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#87613e;}.cls-2{fill:#7ba60d;}.cls-2,.cls-3{fill-rule:evenodd;}.cls-3{fill:#9cc925;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "green-trees") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "green-trees"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 24.54,
    y: 27.6,
    width: 5.16,
    height: 49.34,
    rx: 1.72,
    ry: 1.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 60.31,
    y: 27.6,
    width: 5.16,
    height: 49.34,
    rx: 1.72,
    ry: 1.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 42.42,
    y: 35.66,
    width: 5.16,
    height: 49.34,
    rx: 1.72,
    ry: 1.72
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M62.59,28.07A15.58,15.58,0,1,1,46.85,43.65,15.67,15.67,0,0,1,62.59,28.07Zm-35.19,0A15.58,15.58,0,1,1,11.67,43.65,15.67,15.67,0,0,1,27.41,28.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M45,49.25A22.28,22.28,0,0,0,67.36,27.13a22.36,22.36,0,0,0-44.71,0A22.28,22.28,0,0,0,45,49.25Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCitytree);
export default __webpack_public_path__ + "static/media/citytree.398f141c92755a69960a20d12a89090e.svg";
export { ForwardRef as ReactComponent };